import { z } from "zod";

export const ReferralSourceSchema = z.object({
  sid: z.number(),
  source: z.string().max(50).nullable().optional(),
  scosttype: z.string().max(24).nullable().optional(),
  scostamt: z.string().nullable().optional(),
  scostinterval: z.number().default(1),
});

// Create schema (omit auto-generated fields)
export const CreateReferralSourceSchema = ReferralSourceSchema.omit({ sid: true });

// Update schema (make all fields optional except ID)
export const UpdateReferralSourceSchema = ReferralSourceSchema.partial().required({ sid: true });

// Type definitions
export type ReferralSource = z.infer<typeof ReferralSourceSchema>;
export type CreateReferralSource = z.infer<typeof CreateReferralSourceSchema>;
export type UpdateReferralSource = z.infer<typeof UpdateReferralSourceSchema>; 